export default {
  my_points: 'Meine Punkte',
  loyalty_points: 'Loyalty Punkte',
  already_have_points: 'Hast du bereits Punkte?',
  log_in: 'Log in',
  description: '🔥 Verdiene {{percentage}}p pro {{amount}} Ausgaben',
  buttons: {
    sign_in_sign_up: 'Anmelden/ Registrieren',
    sign_in: 'Anmelden',
  },
  points: {
    label:
      'Erhalte {{reward}} Guthaben für jede {{spend}}, die du ausgibst. Tritt dem {{company}} Rewards-Programm bei!',
  },
};
